<template lang="html">
  <div class="">
    <h1>Account Details</h1>

    <label>Your Name: </label><br>
    <input v-model="$root.data.user.name" type="text">
    <br>
    <label>Your Email: </label><br>
    <span v-text="$root.data.user.email" > </span>
    <br>


  </div>
</template>

<script>
export default {
  name: 'Account',
  computed: {
    journal: function() {
      return this.$root.data.journals[this.$parent.currentJournal]
    },
    exporteth: function() {
      return window.btoa(JSON.stringify(this.$root.data))
    }
  },

}
</script>

<style lang="css" scoped>
.main {
  background: #e7e7e7;
  padding: 20px;
}
input {
  width: 200px;
}
</style>
